export const USStateOptions = [
  { label: 'Armed Forces Americas', value: 'AA', activeProviderState: false },
  { label: 'Armed Forces Europe', value: 'AE', activeProviderState: false },
  { label: 'Australia SaaS', value: 'AU', activeProviderState: false },
  { label: 'Alaska', value: 'AK', activeProviderState: true },
  { label: 'Alabama', value: 'AL', activeProviderState: true },
  { label: 'Armed Forces Pacific', value: 'AP', activeProviderState: false },
  { label: 'Arkansas', value: 'AR', activeProviderState: true },
  { label: 'American Samoa', value: 'AS', activeProviderState: false },
  { label: 'Arizona', value: 'AZ', activeProviderState: true },
  { label: 'California', value: 'CA', activeProviderState: true },
  { label: 'Colorado', value: 'CO', activeProviderState: true },
  { label: 'Connecticut', value: 'CT', activeProviderState: true },
  { label: 'District of Columbia', value: 'DC', activeProviderState: true },
  { label: 'Delaware', value: 'DE', activeProviderState: true },
  { label: 'Florida', value: 'FL', activeProviderState: true },
  { label: 'Georgia', value: 'GA', activeProviderState: true },
  { label: 'Guam', value: 'GU', activeProviderState: false },
  { label: 'Hawaii', value: 'HI', activeProviderState: true },
  { label: 'Iowa', value: 'IA', activeProviderState: true },
  { label: 'Idaho', value: 'ID', activeProviderState: true },
  { label: 'Illinois', value: 'IL', activeProviderState: true },
  { label: 'Indiana', value: 'IN', activeProviderState: true },
  { label: 'Kansas', value: 'KS', activeProviderState: true },
  { label: 'Kentucky', value: 'KY', activeProviderState: true },
  { label: 'Louisiana', value: 'LA', activeProviderState: true },
  { label: 'Massachusetts', value: 'MA', activeProviderState: true },
  { label: 'Maryland', value: 'MD', activeProviderState: true },
  { label: 'Maine', value: 'ME', activeProviderState: true },
  { label: 'Michigan', value: 'MI', activeProviderState: true },
  { label: 'Minnesota', value: 'MN', activeProviderState: true },
  { label: 'Missouri', value: 'MO', activeProviderState: true },
  { label: 'Northern Mariana Islands', value: 'MP', activeProviderState: false },
  { label: 'Mississippi', value: 'MS', activeProviderState: true },
  { label: 'Montana', value: 'MT', activeProviderState: true },
  { label: 'North Carolina', value: 'NC', activeProviderState: true },
  { label: 'North Dakota', value: 'ND', activeProviderState: true },
  { label: 'Nebraska', value: 'NE', activeProviderState: true },
  { label: 'New Hampshire', value: 'NH', activeProviderState: true },
  { label: 'New Jersey', value: 'NJ', activeProviderState: true },
  { label: 'New Mexico', value: 'NM', activeProviderState: true },
  { label: 'Nevada', value: 'NV', activeProviderState: true },
  { label: 'New York', value: 'NY', activeProviderState: true },
  { label: 'Ohio', value: 'OH', activeProviderState: true },
  { label: 'Oklahoma', value: 'OK', activeProviderState: true },
  { label: 'Oregon', value: 'OR', activeProviderState: true },
  { label: 'Pennsylvania', value: 'PA', activeProviderState: true },
  { label: 'Puerto Rico', value: 'PR', activeProviderState: false },
  { label: 'Rhode Island', value: 'RI', activeProviderState: true },
  { label: 'South Carolina', value: 'SC', activeProviderState: true },
  { label: 'South Dakota', value: 'SD', activeProviderState: true },
  { label: 'Tennessee', value: 'TN', activeProviderState: true },
  { label: 'Trusted Territories', value: 'TT', activeProviderState: false },
  { label: 'Texas', value: 'TX', activeProviderState: true },
  { label: 'United States Minor Outlying Islands', value: 'UM', activeProviderState: false },
  { label: 'Utah', value: 'UT', activeProviderState: true },
  { label: 'Virginia', value: 'VA', activeProviderState: true },
  { label: 'Virgin Islands, U.S.', value: 'VI', activeProviderState: false },
  { label: 'Vermont', value: 'VT', activeProviderState: true },
  { label: 'Washington', value: 'WA', activeProviderState: true },
  { label: 'Wisconsin', value: 'WI', activeProviderState: true },
  { label: 'West Virginia', value: 'WV', activeProviderState: true },
  { label: 'Wyoming', value: 'WY', activeProviderState: true }
];

/**
 * US state (and territory) abbreviations, keyed by full name. Use these instead of
 * bare string literals when gating behavior on a specific state so producer and
 * consumer share one source of truth.
 *
 * ex. `if (abbrev === USStateAbbrev.ILLINOIS) ...`
 */
export enum USStateAbbrev {
  ARMED_FORCES_AMERICAS = 'AA',
  ARMED_FORCES_EUROPE = 'AE',
  AUSTRALIA_SAAS = 'AU',
  ALASKA = 'AK',
  ALABAMA = 'AL',
  ARMED_FORCES_PACIFIC = 'AP',
  ARKANSAS = 'AR',
  AMERICAN_SAMOA = 'AS',
  ARIZONA = 'AZ',
  CALIFORNIA = 'CA',
  COLORADO = 'CO',
  CONNECTICUT = 'CT',
  DISTRICT_OF_COLUMBIA = 'DC',
  DELAWARE = 'DE',
  FLORIDA = 'FL',
  GEORGIA = 'GA',
  GUAM = 'GU',
  HAWAII = 'HI',
  IOWA = 'IA',
  IDAHO = 'ID',
  ILLINOIS = 'IL',
  INDIANA = 'IN',
  KANSAS = 'KS',
  KENTUCKY = 'KY',
  LOUISIANA = 'LA',
  MASSACHUSETTS = 'MA',
  MARYLAND = 'MD',
  MAINE = 'ME',
  MICHIGAN = 'MI',
  MINNESOTA = 'MN',
  MISSOURI = 'MO',
  NORTHERN_MARIANA_ISLANDS = 'MP',
  MISSISSIPPI = 'MS',
  MONTANA = 'MT',
  NORTH_CAROLINA = 'NC',
  NORTH_DAKOTA = 'ND',
  NEBRASKA = 'NE',
  NEW_HAMPSHIRE = 'NH',
  NEW_JERSEY = 'NJ',
  NEW_MEXICO = 'NM',
  NEVADA = 'NV',
  NEW_YORK = 'NY',
  OHIO = 'OH',
  OKLAHOMA = 'OK',
  OREGON = 'OR',
  PENNSYLVANIA = 'PA',
  PUERTO_RICO = 'PR',
  RHODE_ISLAND = 'RI',
  SOUTH_CAROLINA = 'SC',
  SOUTH_DAKOTA = 'SD',
  TENNESSEE = 'TN',
  TRUSTED_TERRITORIES = 'TT',
  TEXAS = 'TX',
  UNITED_STATES_MINOR_OUTLYING_ISLANDS = 'UM',
  UTAH = 'UT',
  VIRGINIA = 'VA',
  VIRGIN_ISLANDS = 'VI',
  VERMONT = 'VT',
  WASHINGTON = 'WA',
  WISCONSIN = 'WI',
  WEST_VIRGINIA = 'WV',
  WYOMING = 'WY',
}

export enum SupportedCountries {
  AUSTRALIA = 'AU',
  UNITED_STATES = 'US',
}

export const SupportedCountryOptions = [
  { label: 'United States of America', value: SupportedCountries.UNITED_STATES },
  { label: 'Australia', value: SupportedCountries.AUSTRALIA }
];

export const AUStateOptions = [
  { label: 'Australian Capital Territory', value: 'ACT' },
  { label: 'New South Wales', value: 'NSW' },
  { label: 'Northern Territory', value: 'NT' },
  { label: 'Queensland', value: 'QLD' },
  { label: 'South Australia', value: 'SA' },
  { label: 'Tasmania', value: 'TAS' },
  { label: 'Victoria', value: 'VIC' },
  { label: 'Western Australia', value: 'WA' },
];

export const IsValidStateAbbrev = (abbrev: string): boolean => USStateOptions.map((options) => options.value).includes(abbrev.toLocaleUpperCase());

/**
 * Use this to get state longName from abbreviations more efficiently than with Array.find().
 *
 * ex. stateAbbrevMap['OH'] gets you 'Ohio'
 */

export const USStateAbbrevMap: { [abbrev: string]: string; } =
  USStateOptions.reduce((memo: { [abbrev: string]: string; }, option) => {
    // eslint-disable-next-line no-param-reassign
    memo[option.value] = option.label;
    return memo;
  }, {});

export const USStateNameMap: Array<{ name: string; value: string; }> =
  USStateOptions.reduce((memo: Array<{ name: string; value: string; }>, option) => {
    memo.push({ name: option.label, value: option.value });
    return memo;
  }, []);

export const SupportedCountryMap: Array<{ name: string; value: string; }> =
  SupportedCountryOptions.reduce((memo: Array<{ name: string; value: string; }>, option) => {
    memo.push({ name: option.label, value: option.value });
    return memo;
  }, []);

export const AUStateNameMap: Array<{ name: string; value: string; }> =
  AUStateOptions.reduce((memo: Array<{ name: string; value: string; }>, option) => {
    memo.push({ name: option.label, value: option.value });
    return memo;
  }, []);

export const activeProviderUSStateNameMap: Array<{ name: string; value: string; }> =
  USStateOptions
    .filter((option) => option.activeProviderState)
    .map((option) => ({
      name: option.label,
      value: option.value,
    }));
